module.exports = __webpack_public_path__ + "static/media/login-pattern.1c5a2ebe.png";